import { isLocalEnvironment } from './platform';

type Path = `./${string}`;

/**
 * Outputs the correct link when using builds, make sure to use example format: "./images/image.png"
 * */
const getAssetsPath = (path: Path) => {
  // If we use local ( SSR ) we should use regular vite linking instead since its not supported with method below.
  if (isLocalEnvironment()) {
    return `assets/${path}`;
  }

  return new URL(path, import.meta.url).href;
};

export default getAssetsPath;
